// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const roaring_moon: PokeData = {
  "id": 1005,
  "name": "roaring-moon",
  "height": 20,
  "weight": 3800,
  "base_experience": 295,
  "types": [
    PokeType.DRAGON,
    PokeType.DARK
  ],
  "api_moves": [
    "fly",
    "headbutt",
    "double-edge",
    "leer",
    "bite",
    "flamethrower",
    "focus-energy",
    "scary-face",
    "dragon-breath",
    "dragon-claw",
    "dragon-dance",
    "roost",
    "night-slash",
    "dragon-rush",
    "zen-headbutt",
    "incinerate",
    "throat-chop"
  ],
  "moves": [
    "headbutt",
    "leer",
    "bite",
    "flamethrower",
    "scary-face",
    "dragon-breath",
    "dragon-claw",
    "dragon-dance",
    "roost",
    "night-slash",
    "dragon-rush",
    "zen-headbutt",
    "scale-shot"
  ],
  "evolution_chain": {
    "id": 533,
    "item": null,
    "species": [
      {
        "name": "roaring-moon",
        "order": 985,
        "types": [
          PokeType.DRAGON,
          PokeType.DARK
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 108,
    "speed": 135,
    "ability_power": 157
  },
  "stat_changes": [],
  "catch_rate": 10,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
